import type { FC } from 'react';

import type { CmsDataJsonApi } from '@packages/cms-components/interfaces';
import { Banner } from '@packages/cms-components/src/modules/Banner/Banner';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useMediaType } from '@packages/shared/src/hooks/useMediaType/useMediaType';
import { DynamicYield } from '@packages/shared/src/ui/DynamicYield/DynamicYield';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';

export type CmsTopBannerProps = {
  bannerData: CmsDataJsonApi;
};

/**
 * CmsTopBanner component description displayed in storybook
 * */
export const CmsTopBanner: FC<CmsTopBannerProps> = ({ bannerData }) => {
  const isDesktop = useMediaType();
  const { dynamicYieldEnabled } = useConfig();

  return (
    // Tailwind fallback for max-width on img inside rich text
    <div className="[&_img]:max-w-full">
      {dynamicYieldEnabled && (
        <ErrorBoundary>
          <DynamicYield dataDyId={`mba_topbanner-services-${isDesktop ? 'desktop' : 'mobile'}`} />
          <DynamicYield dataDyId={`mba_campaign-banner-${isDesktop ? 'desktop' : 'mobile'}`} />
        </ErrorBoundary>
      )}
      <ErrorBoundary>
        <Banner bannerData={bannerData} />
      </ErrorBoundary>
    </div>
  );
};
